import type { TTransferPricingBenchmarksResponse } from './useTransferPricingBenchmarks';

type TFetchBenchmarkPage = (
  cursor: string | null
) => Promise<TTransferPricingBenchmarksResponse>;

export class BenchmarkListPagesHelper {
  /** A filtered list comes back a page at a time; the dashboard shows every match, so follow the cursor to the end. */
  static async fetchAll(
    fetchPage: TFetchBenchmarkPage
  ): Promise<TTransferPricingBenchmarksResponse> {
    const firstPage = await fetchPage(null);
    const laterBenchmarks = await BenchmarkListPagesHelper.fetchFrom(
      fetchPage,
      BenchmarkListPagesHelper.readNextCursor(firstPage)
    );
    const benchmarks = [...firstPage.benchmarks, ...laterBenchmarks];
    return { ...firstPage, benchmarks, count: benchmarks.length };
  }

  /** Each page's cursor comes from the one before, so the pages are fetched in turn. */
  private static async fetchFrom(
    fetchPage: TFetchBenchmarkPage,
    cursor: string | null
  ): Promise<TTransferPricingBenchmarksResponse['benchmarks']> {
    if (!cursor) return [];
    const page = await fetchPage(cursor);
    const laterBenchmarks = await BenchmarkListPagesHelper.fetchFrom(
      fetchPage,
      BenchmarkListPagesHelper.readNextCursor(page)
    );
    return [...page.benchmarks, ...laterBenchmarks];
  }

  private static readNextCursor(
    page: Readonly<TTransferPricingBenchmarksResponse>
  ): string | null {
    return page.meta?.hasMore ? (page.meta.nextCursor ?? null) : null;
  }
}
